import { Component, OnInit,OnDestroy, Input, Output ,EventEmitter} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { StudiesService } from 'src/app/shared/services/studies.service';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { surveyPanelService } from 'src/app/serveypanel/survey-panel-service/survey-panel.service';

interface StudyDetails{
  id:string;
  status:string;
  name:string;
  survey_uuid:string;
  survey_name:string;
}

@Component({
  selector: 'app-update-study',
  templateUrl: './update-study.component.html',
  styleUrls: ['./update-study.component.scss']
})
export class UpdateStudyComponent implements OnInit, OnDestroy {
  @Output()updateStudies = new EventEmitter<boolean>();
  @Input() studyDetails: StudyDetails;

  studyName = new FormControl('');
  studyStatus :boolean;
  public obj = [{survey:{id:"a1",name:"test 1"}},{survey:{id:"a2",name:"test 2"}},{survey:{id:"a3",name:"test 3"}}];
  public sobj = {id:"a2",name:"test 2"};
  // survey_id = new FormControl();
  studyForm = new FormGroup({
    name: new FormControl(''),
    study_status: new FormControl(''),
    survey_uuid: new FormControl(''),
    test_id: new FormControl(''),
  });
  // public surveyList:any = [];
  // public filteredSurveyList:any = [];
  public search:string = '';

  constructor(public stydiesService:StudiesService,
    private notifier: NotifierService,
    private router: Router,
    private surveyService: surveyPanelService,
    private logerror: LoginService,
    public notification: NotifierService) { }

    ngOnDestroy(){
      this.hideOldestNotification();
    }

  ngOnInit() {
    this.studyStatus = this.studyDetails.status === '1'?true:false;
    this.stydiesService.loadsurvey(this.search);
  }

  onCreate(){
    this.updateStudy();

  }
  onClose(){
    this.updateStudies.emit(false);
  }

  public showNotification( type: string, message: string ): void {
		this.notifier.notify( type, message );
	}

	public hideOldestNotification(): void {
		this.notifier.hideOldest();
	}

  // statusChange(status){
  //   console.log("status ",status)
  //   this.study_status.setValue(status);
  //   console.log("study_status ",this.study_status.value)
  // }

  updateStudy(){
    let dataStudy = {
      study_id: this.studyDetails.id,
      // status: this.studyStatus ? '1' : '0' 
      // status: '0' 
      name: this.studyForm.value.name ? this.studyForm.value.name : this.studyDetails.name,
      status: this.studyForm.value.study_status == '1' ? 1 : 0,
      survey_uuid:this.studyForm.value.survey_uuid
    };
    // console.log('dataStudy',dataStudy)
  
    this.stydiesService.updateStudy(dataStudy).subscribe(
      (data)=>{
        if(data['status']===1){
          this.updateStudies.emit(true);
          this.showNotification('success', data['message']);
          this.studyForm.reset();
          this.onClose();
        }else{
          this.showNotification('error', data['message']);
        }
      },
      (error)=>{
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.showNotification('error', 'User is not authorised');
        }
        else {
          this.showNotification('error', 'Something went wrong');
        }
      }
    );
  }

  onTextChange(search){
    this.search = search.toLowerCase();
    if (this.search.length>2) {
      this.stydiesService.loadsurvey(this.search,{'isLinkedSurvey':true,'survey':{"name":this.studyDetails.survey_name,"uuid":this.studyDetails.survey_uuid}});
    }
  }

 
}
